import { parseBigQueryRows } from './parseBigQuery';

export const fetchBigQueryData = async (token: string, query: string) => {
  try {
    const { gcpBaseURL } = (window as any).data.auth;
    const tokenResponse = await fetch(`${gcpBaseURL}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!tokenResponse.ok) {
      throw new Error('Failed to fetch GCP token');
    }

    const tokenData = await tokenResponse.json();
    const data = await fetchQueryData(tokenData.gcp_token, query);

    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

const fetchQueryData = async (token: string, query: string) => {
  const { bigQueryURL } = (window as any).data.bigQuery;
  const bigQueryResponse = await fetch(bigQueryURL, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: query,
      useLegacySql: false,
    }),
  });

  if (!bigQueryResponse.ok) {
    throw new Error('Network response was not ok');
  }

  const bigQueryData = await bigQueryResponse.json();

  const rows = parseBigQueryRows(
    bigQueryData.schema.fields,
    bigQueryData.rows ?? []
  );
  return rows;
};
